export default [
  {
    name: '404',
    path: '*',
    component: () => import('@views/404')
  },
  {
    name: 'admin.login',
    path: '/login',
    component: () => import('@views/admin/login')
  },
  {
    path: '/',
    component: () => import('@layouts/LayoutAdmin'),
    meta: {
      title: 'GenScan Admin',
      auth: ['Permissions.AdminPanel.View'],
      redirectOnAuthFail: 'admin.login'
    },
    children: [
      {
        name: 'admin.dashboard',
        path: '',
        meta: {
          title: 'GenScan Admin',
          readableName: 'Dashboard',
          includeInNavbar: false
        },
        component: () => import('@views/admin/dashboard')
      },
      {
        path: 'unpaidcustomers',
        meta: {
          auth: ['Permissions.AdminPanel.UnpaidCustomers.View'],
          redirectOnAuthFail: 'admin.dashboard',
          readableName: 'routes.UnpaidCustomers',
          includeInNavbar: true,
          entity: 'unpaidcustomers'
        },
        component: () => import('@views/admin/unpaidcustomers/index'),
        children: [
          {
            name: 'admin.unpaidcustomers.view',
            path: '',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/unpaidcustomers/view')
          },
          {
            name: 'admin.unpaidcustomers.viewdetail',
            path: 'view/:id',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/unpaidcustomers/viewdetail')
          }
        ]
      },
      {
        path: 'finances',
        meta: {
          redirectOnAuthFail: 'admin.dashboard',
          readableName: 'routeCategories.Finances',
          includeInNavbar: true,
          entity: 'finances'
        },
        component: () => import('@views/admin/finances/index'),
        children: [
          {
            path: 'orders',
            meta: {
              auth: ['Permissions.AdminPanel.Orders.View'],
              includeInNavbar: true,
              readableName: 'routes.Orders',
              entity: 'orders'
            },
            component: () => import('@views/admin/orders/index'),
            children: [
              {
                name: 'admin.finances.orders.view',
                path: '',
                component: () => import('@views/admin/orders/view')
              },
              {
                name: 'admin.orders.viewdetail',
                path: 'view/:id',
                component: () => import('@views/admin/orders/viewdetail')
              },
            ]
          },
          {
            path: 'payments',
            meta: {
              auth: ['Permissions.AdminPanel.Payments.View'],
              includeInNavbar: true,
              readableName: 'routes.Payments',
              entity: 'payments'
            },
            component: () => import('@views/admin/payments/index'),
            children: [
              {
                name: 'admin.finances.payments.view',
                path: '',
                component: () => import('@views/admin/payments/view')
              }
            ]
          }
        ]
      },
      {
        path: 'customers',
        meta: {
          redirectOnAuthFail: 'admin.dashboard',
          readableName: 'routeCategories.Customers',
          includeInNavbar: true,
          entity: 'customers'
        },
        component: () => import('@views/admin/customers/index'),
        children: [
          {
            name: 'admin.customers.view',
            path: '',
            meta: {
              auth: ['Permissions.AdminPanel.Customers.View'],
              includeInNavbar: true,
              main: true,
              entity: 'customers',
              readableName: 'routes.Customers',
            },
            component: () => import('@views/admin/customers/view')
          },
          {
            name: 'admin.customers.create',
            path: 'create',
            meta: {
              auth: ['Permissions.AdminPanel.Customers.Create'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'Customer create',
              includeInNavbar: false
            },
            component: () => import('@views/admin/customers/create')
          },
          {
            name: 'admin.customers.edit',
            path: 'edit/:id',
            meta: {
              auth: ['Permissions.AdminPanel.Customers.Edit'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'Customers edit',
              includeInNavbar: false
            },
            component: () => import('@views/admin/customers/edit')
          },
          {
            name: 'admin.customers.viewdetail',
            path: 'view/:id',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/customers/viewdetail')
          },
          {
            name: 'admin.customers.reservations.history',
            path: 'reservations/:id',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/customers/viewreservations')
          },
          {
            name: 'admin.customerrelationships.view',
            path: 'relationships',
            meta: {
              auth: ['Permissions.AdminPanel.Customers.View'],
              includeInNavbar: true,
              main: true,
              entity: 'customerrelationships',
              readableName: 'routes.CustomerRelationships',
            },
            component: () => import('@views/admin/relationships/view')
          },
          {
            path: 'questionnaires',
            meta: {
              auth: ['Permissions.AdminPanel.Questionnaires.View'],
              readableName: 'routes.Questionnaires',
              includeInNavbar: true,
              entity: 'questionnaires'
            },
            component: () => import('@views/admin/questionnaires/index'),
            children: [
              {
                name: 'admin.customers.questionnaires.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/questionnaires/view')
              },
              {
                name: 'admin.questionnaires.viewdetail',
                path: 'show/:id',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/questionnaires/viewdetail')
              }
            ]
          },
          {
            path: 'samples',
            meta: {
              auth: ['Permissions.AdminPanel.Samples.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.Samples',
              includeInNavbar: true,
              entity: 'samples'
            },
            component: () => import('@views/admin/samples/index'),
            children: [
              {
                name: 'admin.customers.samples.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/samples/view')
              },
              {
                name: 'admin.samples.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.Samples.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Samples edit',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/samples/edit')
              },
              {
                name: 'admin.samples.viewdetail',
                path: 'view/:id',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/samples/viewdetail')
              },
            ]
          },
          {
            path: 'pendingsamples',
            meta: {
              auth: ['Permissions.AdminPanel.Samples.Edit'],
              includeInNavbar: true,
              readableName: 'routes.PendingSamples',
              entity: 'pendingsamples'
            },
            component: () => import('@views/admin/samples/pendingsamples/index'),
            children: [
              {
                name: 'admin.customers.pendingsamples.view',
                path: '',
                component: () => import('@views/admin/samples/pendingsamples/view')
              },
            ]
          },
          {
            path: 'receivingsamples',
            meta: {
              auth: ['Permissions.AdminPanel.Samples.Edit'],
              includeInNavbar: true,
              readableName: 'routes.ReceivingSamples',
              entity: 'receivingsamples'
            },
            component: () => import('@views/admin/samples/receivingsamples/index'),
            children: [
              {
                name: 'admin.customers.receivingsamples.view',
                path: '',
                component: () => import('@views/admin/samples/receivingsamples/view')
              },
            ]
          },
          {
            path: 'waitingforanalysis',
            meta: {
              auth: ['Permissions.AdminPanel.Samples.Edit'],
              includeInNavbar: true,
              readableName: 'routes.SamplesWaitingForAnalysis',
              entity: 'waitingforanalysissamples'
            },
            component: () => import('@views/admin/samples/waitingforanalysissamples/index'),
            children: [
              {
                name: 'admin.customers.waitingforanalysissamples.view',
                path: '',
                component: () => import('@views/admin/samples/waitingforanalysissamples/view')
              }
            ]
          },
          {
            path: 'inanalysis',
            meta: {
              auth: ['Permissions.AdminPanel.Samples.Edit'],
              includeInNavbar: true,
              readableName: 'routes.SamplesInAnalysis',
              entity: 'samplesinanalysis'
            },
            component: () => import('@views/admin/samples/samplesinanalysis/index'),
            children: [
              {
                name: 'admin.customers.samplesinanalysis.view',
                path: '',
                component: () => import('@views/admin/samples/samplesinanalysis/view')
              },
            ]
          },
          {
            path: 'products',
            meta: {
              auth: ['Permissions.AdminPanel.Products.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.Products',
              includeInNavbar: true,
              entity: 'products'
            },
            component: () => import('@views/admin/products/index'),
            children: [
              {
                name: 'admin.customers.products.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/products/view')
              },
              {
                name: 'admin.products.viewdetail',
                path: ':id',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/products/viewdetail')
              },
              {
                name: 'admin.products.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.Products.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Products edit',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/products/edit')
              },
            ]
          },
          {
            path: 'products-doctorsection',
            meta: {
              auth: ['Permissions.AdminPanel.Products.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.ProductBuilds',
              includeInNavbar: true,
              entity: 'product-builds'
            },
            component: () => import('@views/admin/products/index'),
            children: [
              {
                name: 'admin.customers.product-builds.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/products/builds/view')
              },
              {
                name: 'admin.products/doctorsection.viewdetail',
                path: ':id',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/products/viewdetail')
              },
              {
                name: 'admin.products/doctorsection.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.Products.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Products edit',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/products/edit')
              },
            ]
          },
          {
            path: 'archive',
            meta: {
              auth: ['Permissions.AdminPanel.Products.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.ProductsArchive',
              includeInNavbar: true,
              entity: 'archive'
            },
            component: () => import('@views/admin/products/index'),
            children: [
              {
                name: 'admin.customers.archive.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/products/archive/view')
              },
              {
                name: 'admin.products/archived.viewdetail',
                path: ':id',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/products/viewdetail')
              },
            ]
          }
        ]
      },
      {
        path: 'results',
        meta: {
          auth: ['Permissions.AdminPanel.Results.View', 'Permissions.AdminPanel.Results.Upload'],
          redirectOnAuthFail: 'admin.dashboard',
          readableName: 'routes.Results',
          includeInNavbar: true,
          entity: 'results'
        },
        component: () => import('@views/admin/results/index'),
        children: [
          {
            name: 'admin.results.view',
            path: '',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/results/view')
          },
          {
            name: 'admin.results.viewdetail',
            path: ':id',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/results/viewdetail')
          }
        ]
      },
      {
        path: 'reservations',
        meta: {
          auth: ['Permissions.AdminPanel.Reservations.View'],
          redirectOnAuthFail: 'admin.dashboard',
          readableName: 'routeCategories.Reservations',
          includeInNavbar: true,
          entity: 'reservations'
        },
        component: () => import('@views/admin/reservations/index'),
        children: [
          {
            name: 'admin.reservations.view',
            path: '',
            meta: {
              readableName: 'routes.Reservations',
              includeInNavbar: true,
              entity: 'reservations',
              main: true,
            },
            component: () => import('@views/admin/reservations/view')
          },
          {
            path: 'consultingrooms',
            meta: {
              includeInNavbar: true,
              auth: ['Permissions.AdminPanel.ConsultingRooms.View'],
              readableName: 'routes.ConsultingRooms',
              entity: 'consultingrooms'
            },
            component: () => import('@views/admin/reservations/consultingrooms/index'),
            children: [
              {
                name: 'admin.reservations.consultingrooms.view',
                path: '',
                component: () => import('@views/admin/reservations/consultingrooms/view')
              },
              {
                name: 'admin.consultingrooms.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.ConsultingRooms.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Consulting room edit'
                },
                component: () => import('@views/admin/reservations/consultingrooms/edit')
              },
              {
                name: 'admin.consultingrooms.viewdetail',
                path: 'show/:id',
                component: () => import('@views/admin/reservations/consultingrooms/viewdetail')
              },
              {
                name: 'admin.reservations.consultingrooms.create',
                path: 'create',
                meta: {
                  auth: ['Permissions.AdminPanel.ConsultingRooms.Create'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Consulting room create',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/reservations/consultingrooms/create')
              }
            ]
          },
        ]
      },
      {
        path: 'vouchers',
        meta: {
          auth: ['Permissions.AdminPanel.Vouchers.View'],
          redirectOnAuthFail: 'admin.dashboard',
          readableName: 'routes.Vouchers',
          includeInNavbar: true,
          entity: 'vouchers'
        },
        component: () => import('@views/admin/vouchers/index'),
        children: [
          {
            name: 'admin.vouchers.view',
            path: '',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/vouchers/view')
          },
          {
            name: 'admin.vouchers.moneyvouchers.viewdetail',
            path: 'money/view/:id',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/vouchers/viewdetailMoney')
          },
          {
            name: 'admin.vouchers.productvouchers.viewdetail',
            path: 'product/view/:id',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/vouchers/viewdetailProduct')
          },
          {
            name: 'admin.vouchers.moneyvouchers.edit',
            path: 'money/edit/:id',
            meta: {
              auth: ['Permissions.AdminPanel.Vouchers.Edit'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'Money voucher edit',
              includeInNavbar: false
            },
            component: () => import('@views/admin/vouchers/editMoney')
          },
          {
            name: 'admin.vouchers.productvouchers.edit',
            path: 'product/edit/:id',
            meta: {
              auth: ['Permissions.AdminPanel.Vouchers.Edit'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'Product vouchers edit',
              includeInNavbar: false
            },
            component: () => import('@views/admin/vouchers/editProduct')
          },
          {
            name: 'admin.vouchers.moneyvouchers.create',
            path: 'money/create',
            meta: {
              auth: ['Permissions.AdminPanel.Vouchers.Create'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'Money voucher create',
              includeInNavbar: false
            },
            component: () => import('@views/admin/vouchers/createMoney')
          },
          {
            name: 'admin.vouchers.productvouchers.create',
            path: 'product/create',
            meta: {
              auth: ['Permissions.AdminPanel.Vouchers.Create'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'Product voucher create',
              includeInNavbar: false
            },
            component: () => import('@views/admin/vouchers/createProduct')
          },
        ]
      },
      {
        path: 'templates',
        meta: {
          auth: ['Permissions.AdminPanel.Templates.View'],
          redirectOnAuthFail: 'admin.dashboard',
          readableName: 'routeCategories.Templates',
          includeInNavbar: true,
          entity: 'templates'
        },
        component: () => import('@views/admin/templates/index'),
        children: [
          {
            name: 'admin.templates.view',
            path: '',
            meta: {
              includeInNavbar: true,
              main: true,
              entity: 'templates',
              readableName: 'routes.Templates',
            },
            component: () => import('@views/admin/templates/view')
          },
          {
            name: 'admin.templates.create',
            path: 'create',
            meta: {
              auth: ['Permissions.AdminPanel.Templates.Create'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'Template create',
              includeInNavbar: false
            },
            component: () => import('@views/admin/templates/createedit')
          },
          {
            name: 'admin.templates.edit',
            path: 'edit/:id',
            meta: {
              auth: ['Permissions.AdminPanel.Templates.Edit'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'Template edit',
              includeInNavbar: false
            },
            component: () => import('@views/admin/templates/createedit')
          },
          {
            name: 'admin.templates.viewdetail',
            path: 'show/:id',
            meta: {
              includeInNavbar: false
            },
            component: () => import('@views/admin/templates/viewdetail')
          },
          {
            path: 'genecombinations',
            meta: {
              includeInNavbar: true,
              readableName: 'routes.Phenotypes',
              entity: 'genecombinations'
            },
            component: () => import('@views/admin/templates/genecombinations/index'),
            children: [
              {
                name: 'admin.templates.genecombinations.view',
                path: '',
                component: () => import('@views/admin/templates/genecombinations/view')
              },
              {
                name: 'admin.templates.genecombinations.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.Templates.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Gene combination edit'
                },
                component: () => import('@views/admin/templates/genecombinations/edit')
              },
              {
                name: 'admin.templates.genecombinations.viewdetail',
                path: 'show/:id',
                component: () => import('@views/admin/templates/genecombinations/viewdetail')
              }
            ]
          },
          {
            path: 'templatecategories',
            meta: {
              includeInNavbar: true,
              readableName: 'routes.TemplateCategories',
              entity: 'templatecategories'
            },
            component: () => import('@views/admin/templates/templatecategories/index'),
            children: [
              {
                name: 'admin.templates.templatecategories.view',
                path: '',
                component: () => import('@views/admin/templates/templatecategories/view')
              },
              {
                name: 'admin.templates.templatecategories.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.Templates.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Template category edit'
                },
                component: () => import('@views/admin/templates/templatecategories/edit')
              },
              {
                name: 'admin.templates.templatecategories.viewdetail',
                path: 'show/:id',
                component: () => import('@views/admin/templates/templatecategories/viewdetail')
              },
            ]
          }
        ]
      },
      {
        path: 'administration',
        meta: {
          redirectOnAuthFail: 'admin.dashboard',
          readableName: 'routeCategories.Administration',
          includeInNavbar: true,
          entity: 'users'
        },
        component: () => import('@views/admin/users/index'),
        children: [
          {
            path: 'users',
            meta: {
              auth: ['Permissions.AdminPanel.Users.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.Users',
              includeInNavbar: true,
              entity: 'users',
              main: true
            },
            component: () => import('@views/admin/users/index'),
            children: [
              {
                name: 'admin.users.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/users/view')
              },
              {
                name: 'admin.users.create',
                path: 'create',
                meta: {
                  auth: ['Permissions.AdminPanel.Users.Create'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'User create',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/users/create')
              },
              {
                name: 'admin.users.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.Users.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Users edit',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/users/edit')
              },
              {
                name: 'admin.users.viewdetail',
                path: 'view/:id',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/users/viewdetail')
              }
            ]
          },
          {
            path: 'roles',
            meta: {
              auth: ['Permissions.AdminPanel.Roles.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.RoleManagement',
              includeInNavbar: true,
              entity: 'roles'
            },
            component: () => import('@views/admin/roles/index'),
            children: [
              {
                name: 'admin.users.roles.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/roles/view')
              },
              {
                name: 'admin.roles.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.Roles.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Roles edit',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/roles/edit')
              },
              {
                name: 'admin.roles.viewdetail',
                path: 'view/:id',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/roles/viewdetail')
              }
            ]
          },
          {
            path: 'producttypes',
            meta: {
              auth: ['Permissions.AdminPanel.ProductTypes.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.ProductTypes',
              includeInNavbar: true,
              entity: 'producttypes'
            },
            component: () => import('@views/admin/producttypes/index'),
            children: [
              {
                name: 'admin.users.producttypes.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/producttypes/view')
              },
              {
                name: 'admin.producttypes.create',
                path: 'create',
                meta: {
                  auth: ['Permissions.AdminPanel.ProductTypes.Create'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Product type create',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/producttypes/create')
              },
              {
                name: 'admin.producttypes.edit',
                path: 'edit/:id',
                meta: {
                  auth: ['Permissions.AdminPanel.ProductTypes.Edit'],
                  redirectOnAuthFail: 'admin.dashboard',
                  readableName: 'Product type edit',
                  includeInNavbar: false
                },
                component: () => import('@views/admin/producttypes/edit')
              },
              {
                name: 'admin.producttypes.viewdetail',
                path: 'view/:id',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/producttypes/viewdetail')
              }
            ]
          },
          {
            path: 'barcodes',
            meta: {
              auth: ['Permissions.AdminPanel.Barcodes.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.Barcodes',
              includeInNavbar: true,
              entity: 'barcodes'
            },
            component: () => import('@views/admin/barcodes/index'),
            children: [
              {
                name: 'admin.users.barcodes.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/barcodes/view')
              },
            ]
          },
          {
            path: 'email',
            meta: {
              auth: ['Permissions.AdminPanel.Barcodes.View'],
              redirectOnAuthFail: 'admin.dashboard',
              readableName: 'routes.Email',
              includeInNavbar: true,
              entity: 'email'
            },
            component: () => import('@views/admin/email/index'),
            children: [
              {
                name: 'admin.users.email.view',
                path: '',
                meta: {
                  includeInNavbar: false
                },
                component: () => import('@views/admin/email/view')
              },
            ]
          }
        ]
      },

      {
        name: 'admin.userdetail',
        path: 'user',
        meta: {
          includeInNavbar: false
        },
        component: () => import('@views/admin/userdetail')
      },


    ]
  }
];
